import { string, object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  note: string().max(500, 'Max length - 500 symbols').required('Field is required'),
});

export default yupResolver(validationSchema);
